<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 17">
    <g fill="#666" fill-rule="evenodd">
      <path
        d="M11.303 13.697H9.907a.711.711 0 0 1-.715-.706c0-.39.32-.707.715-.707h1.396a.24.24 0 0 0 .242-.238V7.48c0-.39.32-.707.716-.707.395 0 .716.316.716.707v4.565c0 .91-.75 1.65-1.674 1.65m-9.629.002H3.07a.711.711 0 0 0 .715-.706c0-.39-.32-.707-.715-.707H1.674a.24.24 0 0 1-.242-.238V7.48c0-.39-.32-.707-.716-.707A.711.711 0 0 0 0 7.481v4.565c0 .91.75 1.65 1.674 1.65"
      />
      <path
        d="M1.674 5.318H6.38a.71.71 0 0 1 .715.706.71.71 0 0 1-.715.706H1.674a.24.24 0 0 0-.242.239v4.565a.71.71 0 0 1-.716.706.711.711 0 0 1-.716-.706V6.97c0-.91.75-1.651 1.674-1.651"
      />
      <path
        d="M11.303 5.318H6.596a.711.711 0 0 0-.716.706c0 .39.32.706.716.706h4.707a.24.24 0 0 1 .242.239v4.565c0 .39.32.706.716.706a.711.711 0 0 0 .716-.706V6.97c0-.91-.75-1.651-1.674-1.651"
      />
      <path
        d="M8.582 16.878H5.69a.711.711 0 0 1-.716-.706c0-.39.32-.706.716-.706h2.893a.24.24 0 0 0 .242-.239v-4.863c0-.39.32-.707.716-.707.395 0 .716.317.716.707v4.863c0 .91-.75 1.651-1.674 1.651"
      />
      <path
        d="M4.395 16.878h2.59a.711.711 0 0 0 .716-.706.71.71 0 0 0-.716-.706h-2.59a.24.24 0 0 1-.242-.239v-4.863c0-.39-.32-.707-.716-.707a.711.711 0 0 0-.716.707v4.863c0 .91.75 1.651 1.674 1.651"
      />
      <path
        d="M4.395 8.817h2.893c.395 0 .716.316.716.706a.71.71 0 0 1-.716.706H4.395a.24.24 0 0 0-.242.239v4.863c0 .39-.32.707-.716.707a.711.711 0 0 1-.716-.707v-4.863c0-.91.75-1.651 1.674-1.651"
      />
      <path
        d="M5.992 8.817a.711.711 0 0 0-.716.706c0 .39.32.706.716.706h2.59a.24.24 0 0 1 .242.239v4.863c0 .39.32.707.716.707a.711.711 0 0 0 .716-.707v-4.863c0-.91-.75-1.651-1.674-1.651h-2.59zM4.395 0h2.893c.395 0 .716.316.716.706a.71.71 0 0 1-.716.706H4.395a.24.24 0 0 0-.242.24v2.476c0 .39-.32.707-.716.707a.711.711 0 0 1-.716-.707V1.651C2.721.741 3.471 0 4.395 0"
      />
      <path
        d="M8.582 0h-2.59a.711.711 0 0 0-.716.706c0 .39.32.706.716.706h2.59a.24.24 0 0 1 .242.24v2.476c0 .39.32.707.716.707a.711.711 0 0 0 .716-.707V1.651C10.256.741 9.506 0 8.582 0"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'PrintIcon',
};
</script>
